var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordianArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24815 2.16052C8.22493 2.13724 8.19734 2.11876 8.16697 2.10616C8.1366 2.09356 8.10404 2.08707 8.07115 2.08707C8.03827 2.08707 8.00571 2.09356 7.97534 2.10616C7.94496 2.11876 7.91738 2.13724 7.89415 2.16052L1.53015 8.52452C1.46149 8.5982 1.37869 8.65731 1.28669 8.6983C1.19469 8.73929 1.09538 8.76133 0.994676 8.76311C0.893973 8.76489 0.793944 8.74636 0.700556 8.70864C0.607168 8.67092 0.522334 8.61477 0.451115 8.54355C0.379896 8.47234 0.323752 8.3875 0.286031 8.29411C0.24831 8.20073 0.229785 8.1007 0.231562 7.99999C0.233339 7.89929 0.25538 7.79998 0.296372 7.70798C0.337364 7.61598 0.396466 7.53318 0.470153 7.46452L6.83315 1.10052C6.99566 0.937995 7.18858 0.809075 7.40092 0.721118C7.61325 0.633162 7.84083 0.587891 8.07065 0.587891C8.30048 0.587891 8.52806 0.633162 8.74039 0.721118C8.95272 0.809075 9.14565 0.937995 9.30815 1.10052L15.6722 7.46452C15.8046 7.60669 15.8768 7.79474 15.8733 7.98904C15.8699 8.18334 15.7912 8.36873 15.6538 8.50614C15.5164 8.64355 15.331 8.72226 15.1367 8.72569C14.9424 8.72912 14.7543 8.657 14.6122 8.52452L8.24815 2.16052Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianArrow);
export default __webpack_public_path__ + "static/media/accordian-arrow.b30a71e4bc9391ec191ca3c4e9f6bf5b.svg";
export { ForwardRef as ReactComponent };